// extracted by mini-css-extract-plugin
export default {"saveButton":"saveButton_saveButton__x8T-V","large":"saveButton_large__+OSgT","icon":"saveButton_icon__kS+RS"};